"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

require("../styles/storyboards.scss");

function getArchiveModalSubtitle(archivedFilter, organisationName) {
  return _react.default.createElement("span", null, archivedFilter === 'ARCHIVED' ? 'Unarchiving this storyboard will make this visible for everyone within ' : 'Archiving this storyboard will make this hidden from view from everyone within ', _react.default.createElement("strong", null, organisationName), ".");
}

var MODAL = {
  DELETE: 'DELETE',
  ARCHIVE: 'ARCHIVE'
};
var LIST_FILTERS = {
  ARCHIVED_FILTER: [{
    label: 'Active',
    value: 'ACTIVE'
  }, {
    label: 'Archived',
    value: 'ARCHIVED'
  }]
};

function withFirstShot(key, shots, childFn) {
  var _ref = shots && shots.length ? shots[0] : {},
      assetId = _ref.assetId;

  return _react.default.createElement(_commonReact.AssetSelector, {
    key: key,
    assetId: assetId
  }, function (asset) {
    var sourceUrl = asset ? asset.assetFiles.ORIGINAL.sourceUrl : '';
    return childFn({
      sourceUrl: sourceUrl,
      isDeleted: asset === null
    });
  });
}

var ListStoryboards = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ListStoryboards, _Component);

  function ListStoryboards(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ListStoryboards);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListStoryboards).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleStoryboardAction", (0, _lodash.default)(function (_ref2) {
      var actionRequest = _ref2.actionRequest,
          storyboardId = _ref2.storyboardId;
      return function _callee() {
        return _regenerator.default.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _regenerator.default.awrap(actionRequest(storyboardId));

              case 2:
                _this.fetchData();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        });
      };
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openConfirmArchiveModal", (0, _lodash.default)(function (_ref3) {
      var storyboardId = _ref3.storyboardId,
          name = _ref3.name;
      return function () {
        _this.setState({
          modalOpened: MODAL.ARCHIVE,
          storyboardId: storyboardId,
          name: name
        });
      };
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchData", function _callee2() {
      var _this$props, getStoryboards, getArchivedStoryboards, fetchAssetsForResource, archivedFilter, getStoryboardsRequest, storyboardsField, _ref4, data, error, storyboards;

      return _regenerator.default.async(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, getStoryboards = _this$props.getStoryboards, getArchivedStoryboards = _this$props.getArchivedStoryboards, fetchAssetsForResource = _this$props.fetchAssetsForResource;
              archivedFilter = _this.state.archivedFilter;
              getStoryboardsRequest = archivedFilter === 'ARCHIVED' ? getArchivedStoryboards : getStoryboards;
              storyboardsField = archivedFilter === 'ARCHIVED' ? 'getArchivedStoryboards' : 'getStoryboards';
              _context2.next = 6;
              return _regenerator.default.awrap(getStoryboardsRequest());

            case 6:
              _ref4 = _context2.sent;
              data = _ref4.data;
              error = _ref4.error;

              if (!error) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                loading: false,
                error: error
              }));

            case 11:
              storyboards = data[storyboardsField];
              storyboards.forEach(function (storyboard) {
                fetchAssetsForResource({
                  data: storyboard,
                  resourceId: storyboard.storyboardId,
                  organisationId: storyboard.organisationId
                });
              });
              return _context2.abrupt("return", void _this.setState({
                loading: false,
                storyboards: data[storyboardsField]
              }));

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "gotoStoryboard", function (storyboardId) {
      return function () {
        var history = _this.props.history;
        return void history.push("edit/".concat(storyboardId));
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCreateStoryboard", function _callee3() {
      var createStoryboard, _ref5, data;

      return _regenerator.default.async(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              createStoryboard = _this.props.createStoryboard;

              _this.setState({
                saving: true
              });

              _context3.next = 4;
              return _regenerator.default.awrap(createStoryboard());

            case 4:
              _ref5 = _context3.sent;
              data = _ref5.data;

              _this.setState({
                saving: false
              });

              if (!(!data || !data.createStoryboard)) {
                _context3.next = 9;
                break;
              }

              return _context3.abrupt("return");

            case 9:
              _this.gotoStoryboard(data.createStoryboard.storyboardId)();

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFilterChange", function (_ref6) {
      var ARCHIVED_FILTER = _ref6.filters.ARCHIVED_FILTER,
          searchTerm = _ref6.searchTerm;
      var archivedFilter = _this.state.archivedFilter;

      if (archivedFilter === ARCHIVED_FILTER) {
        return void _this.setState({
          searchTerm: searchTerm
        });
      }

      _this.setState({
        searchTerm: searchTerm,
        archivedFilter: ARCHIVED_FILTER
      }, function () {
        return _this.fetchData();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getFilteredStoryboards", function () {
      var _this$state = _this.state,
          _this$state$storyboar = _this$state.storyboards,
          storyboards = _this$state$storyboar === void 0 ? [] : _this$state$storyboar,
          searchTerm = _this$state.searchTerm;

      if (!searchTerm) {
        return storyboards;
      }

      return storyboards.filter(function (item) {
        return Object.values(item).some(function (dataField) {
          return dataField && typeof dataField === 'string' && dataField.toLowerCase().includes(searchTerm.toLowerCase());
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onArchive", function _callee4() {
      var _this$props2, archiveStoryboard, unarchiveStoryboard, _this$state2, storyboardId, name, archivedFilter, showArchived, action, actionRequest, _ref7, error;

      return _regenerator.default.async(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props2 = _this.props, archiveStoryboard = _this$props2.archiveStoryboard, unarchiveStoryboard = _this$props2.unarchiveStoryboard;
              _this$state2 = _this.state, storyboardId = _this$state2.storyboardId, name = _this$state2.name, archivedFilter = _this$state2.archivedFilter;
              showArchived = archivedFilter === 'ARCHIVED';
              action = showArchived ? 'unarchived' : 'archived';
              actionRequest = showArchived ? unarchiveStoryboard : archiveStoryboard;
              _context4.next = 7;
              return _regenerator.default.awrap(actionRequest(storyboardId));

            case 7:
              _ref7 = _context4.sent;
              error = _ref7.error;

              if (!error) {
                _context4.next = 11;
                break;
              }

              return _context4.abrupt("return", void _this.setState({
                error: error
              }));

            case 11:
              _this.setState({
                modalOpened: void 0
              }, function () {
                (0, _commonReact.notify)({
                  content: "".concat(name, " successfully ").concat(action),
                  type: 'success'
                });

                _this.fetchData();
              });

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onComplete", function () {
      var name = _this.state.name;

      _this.setState({
        modalOpened: void 0
      }, function () {
        (0, _commonReact.notify)({
          content: "".concat(name, " successfully deleted"),
          type: 'success'
        });

        _this.fetchData();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hideModal", function () {
      _this.setState({
        modalOpened: void 0
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDeleteStoryboard", function (_ref8) {
      var storyboardId = _ref8.storyboardId,
          name = _ref8.name;
      return function () {
        _this.setState({
          modalOpened: MODAL.DELETE,
          storyboardId: storyboardId,
          name: name || 'NEW STORYBOARD'
        });
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderRecentListItem", function (_ref9) {
      var storyboardId = _ref9.storyboardId,
          name = _ref9.name,
          shots = _ref9.shots;
      return withFirstShot("recent-".concat(storyboardId), shots, function (_ref10) {
        var sourceUrl = _ref10.sourceUrl,
            isDeleted = _ref10.isDeleted;
        return _react.default.createElement("div", {
          className: "storyboards__card__wrapper"
        }, _react.default.createElement("div", {
          style: {
            backgroundImage: "url(".concat(sourceUrl, ")")
          },
          tabIndex: 0,
          role: "button",
          onKeyDown: _this.gotoStoryboard(storyboardId),
          className: "storyboards__card",
          onClick: _this.gotoStoryboard(storyboardId),
          "data-cy": storyboardId
        }, isDeleted && _react.default.createElement(_uiKit.Icon, {
          name: "brokenlink",
          size: 100,
          color: "russian"
        }), !sourceUrl && !isDeleted && _react.default.createElement(_uiKit.Icon, {
          name: "storyboard",
          size: 100,
          color: "russian"
        })), _react.default.createElement("h2", {
          className: "storyboards__card__title"
        }, name || 'NEW STORYBOARD'));
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderListItem", function (_ref11) {
      var storyboardId = _ref11.storyboardId,
          name = _ref11.name,
          updatedAt = _ref11.updatedAt,
          resourcePermissions = _ref11.permissions,
          shots = _ref11.shots;
      var duplicateStoryboard = _this.props.duplicateStoryboard;
      var archivedFilter = _this.state.archivedFilter;
      var actionOptions = [{
        action: _this.gotoStoryboard(storyboardId),
        label: 'EDIT STORYBOARD',
        requiredPermission: 'READ'
      }, {
        action: _this.handleStoryboardAction({
          actionRequest: duplicateStoryboard,
          storyboardId: storyboardId
        }),
        label: 'DUPLICATE',
        requiredPermission: 'READ'
      }, {
        action: _this.openConfirmArchiveModal({
          storyboardId: storyboardId,
          name: name
        }),
        label: archivedFilter === 'ARCHIVED' ? 'UNARCHIVE' : 'ARCHIVE',
        requiredPermission: 'ARCHIVE'
      }, {
        action: _this.handleDeleteStoryboard({
          storyboardId: storyboardId,
          name: name
        }),
        label: 'DELETE',
        isRed: true,
        requiredPermission: 'DELETE'
      }];
      return withFirstShot("list-item-".concat(storyboardId), shots, function (_ref12) {
        var sourceUrl = _ref12.sourceUrl,
            isDeleted = _ref12.isDeleted;
        return _react.default.createElement(_uiKit.List.ListItem, {
          className: (0, _classnames.default)('list-item', {
            'list-item__deleted': isDeleted
          }),
          onClick: _this.gotoStoryboard(storyboardId),
          actionPopupOptions: actionOptions.filter(function (_ref13) {
            var requiredPermission = _ref13.requiredPermission;
            return (0, _commonReact.hasPermission)(requiredPermission, resourcePermissions);
          }),
          defaultImage: sourceUrl,
          defaultImageIcon: isDeleted ? 'brokenlink' : 'storyboard'
        }, _react.default.createElement("div", {
          className: "list-item__name"
        }, _react.default.createElement("h3", {
          className: "list-item__name__text"
        }, name || 'New Storyboard')), _react.default.createElement("div", {
          className: "list-item__timestamp"
        }, _react.default.createElement("p", {
          className: "list-item__timestamp__text"
        }, _react.default.createElement("strong", null, " ".concat((0, _moment.default)(updatedAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('YYYY/MM/DD'), " at ").concat((0, _moment.default)(updatedAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('h:mma z').toUpperCase()))), _react.default.createElement("p", {
          className: "list-item__timestamp__text"
        }, "Last Updated")));
      });
    });
    _this.state = {
      searchTerm: '',
      archivedFilter: '',
      loading: true,
      saving: false,
      modalOpened: void 0,
      name: ''
    };
    return _this;
  }

  (0, _createClass2.default)(ListStoryboards, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevOrganisationId = prevProps.organisationId;
      var organisationId = this.props.organisationId;

      if (prevOrganisationId === organisationId) {
        return;
      }

      this.fetchData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          history = _this$props3.history,
          organisationName = _this$props3.organisationName,
          deleteStoryboard = _this$props3.deleteStoryboard;
      var _this$state3 = this.state,
          storyboards = _this$state3.storyboards,
          loading = _this$state3.loading,
          saving = _this$state3.saving,
          error = _this$state3.error,
          modalOpened = _this$state3.modalOpened,
          archivedFilter = _this$state3.archivedFilter,
          storyboardId = _this$state3.storyboardId,
          name = _this$state3.name;

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      return _react.default.createElement("div", {
        className: "storyboards page"
      }, _react.default.createElement(_uiKit.PageHeader, {
        title: "Manage Storyboards",
        subtitle: organisationName,
        actionBtnText: "Create New Board",
        actionBtnOnClick: this.handleCreateStoryboard,
        actionBtnBusy: saving
      }), _react.default.createElement("div", {
        className: "page__content"
      }, _react.default.createElement(_uiKit.RecentList, {
        onCreate: this.handleCreateStoryboard,
        createText: "Create New Board",
        data: storyboards,
        renderElement: this.renderRecentListItem
      }), _react.default.createElement(_uiKit.List, {
        listKey: "storyboardId",
        history: history,
        data: this.getFilteredStoryboards(),
        loading: loading,
        filters: LIST_FILTERS,
        onFiltersChange: this.handleFilterChange,
        renderListItem: this.renderListItem
      }), _react.default.createElement(_commonReact.ConfirmationModal, {
        title: "Are you sure?",
        subtitle: getArchiveModalSubtitle(archivedFilter, organisationName),
        visible: storyboardId && modalOpened === MODAL.ARCHIVE,
        onClose: this.hideModal,
        onSave: this.onArchive
      }), modalOpened === MODAL.DELETE && _react.default.createElement(_commonReact.DeleteConfirmationModal, {
        onDelete: deleteStoryboard,
        objectId: storyboardId,
        hideModal: this.hideModal,
        onComplete: this.onComplete,
        title: "Delete ".concat(name || 'New Storyboard', "?"),
        subTitle: "Are you sure you want to delete ".concat(name || 'New Storyboard', "?")
      })));
    }
  }]);
  return ListStoryboards;
}(_react.Component);

var _default = ListStoryboards;
exports.default = _default;